<template>
  <!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 2376 2622"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    xml:space="preserve"
    xmlns:serif="http://www.serif.com/"
    style="
      fill-rule: evenodd;
      clip-rule: evenodd;
      stroke-linejoin: round;
      stroke-miterlimit: 2;
    "
  >
    <g id="beanie_2_front">
      <path
        id="beanie-primary-color"
        d="M2277.65,1702.25l3.85,-0.282c-0,-0 21.562,-0.841 30.469,10.693c11.404,8.813 12.161,23.131 13.278,35.706c4.964,55.926 10.009,111.851 13.984,167.857c4.099,57.728 3.536,115.036 5.195,172.749l10.962,131.586c9.369,54.402 8.17,112.699 12.613,167.747c0.078,0.98 12.175,73.076 0.476,91.768c-19.019,30.388 -65.173,31.164 -100.052,39.448c-158.473,37.638 -322.062,46.791 -483.861,58.918c-371.394,27.839 -743.904,40.307 -1116.31,26.303c-212.628,-7.996 -455.241,1.974 -643.257,-111.254c-55.478,-33.411 5.535,-205.008 7.806,-217.742c28.302,-158.744 38.819,-304.664 37.365,-466.423c-0.642,-71.488 -10.388,-100.691 64.744,-112.24c0,0 2.052,0.299 6.066,0.856c13.973,-98.986 33.213,-196.999 47.409,-295.9c22.724,-158.331 37.97,-327.049 126.173,-465.228l0.008,-0c100.681,-158.215 241.588,-310.627 399.238,-411.885c-0,0 456.623,-228.315 1009.85,-14.489c50.021,16.374 90.787,53.947 131.873,86.846c105.208,84.245 186.572,167.247 242.974,290.039l0.134,-0.026c77.014,168.661 105.591,370.378 145.806,549.043l0.977,4.531l-0.059,0.016c8.832,41.754 23.919,128.056 26.48,158.368c2.155,25.628 4.557,70.299 5.804,102.995Z"
        :style="{
          fill: productColors.primary_1.value,
          transition: 'all 500ms ease',
          stroke: 'black',
          strokeWidth: '2',
        }"
      />
      <path
        id="beanie-secondary-color"
        d="M2254.48,1487.73c-0.438,0.09 -0.778,0.17 -1.037,0.259c-691.797,176.723 -1380.63,170.292 -2086.82,45.862c1.824,-9.54 3.56,-19.082 5.205,-28.614c5.643,-31.566 11.276,-63.132 16.132,-94.787c5.374,-35.982 9.54,-72.136 14.996,-108.127c7.377,-48.726 14.837,-97.023 25.194,-145.238c6.445,-30.001 14.382,-59.449 24.551,-88.717c3.455,-9.941 6.047,-17.564 9.794,-27.23c692.924,114.199 1313.91,112.976 1865.39,-23.078c3.121,-0.778 9.6,-1.976 18.792,-3.97c5.844,19.005 11.577,37.788 16.79,57.057c5.726,21.165 8.355,31.459 13.12,51.238c13.215,54.847 29.955,128.647 43.214,195.271c8.388,42.152 17.238,83.971 26.689,125.936c3.201,14.566 5.464,29.312 7.976,44.138"
        :style="{
          fill: productColors.primary_2.value,
          transition: 'all 500ms ease',
        }"
      />
      <path
        id="pom-pom-color-1"
        d="M966.505,500.387l-22.64,-3.228l-48.708,19.163l-44.21,-19.163l89.94,-19.137l33.346,6.92l12.535,-25.046c-4.637,1.36 -10.561,1.892 -18.133,0.979l-64.605,20.023l-11.768,-44.155l91.343,-20.656l1.762,-5.637l-62.153,1.228l-53.081,-6.635l-4.426,-41.975l63.373,23.554l59.745,12.764l5.295,-16.945c-3.996,-3.923 -8.748,-7.298 -14.382,-9.589l-37.365,7.868l-11.349,-4.777c-5.679,1.804 -10.296,0.608 -27.932,-11.759l-16.777,-7.063l12.834,-2.846l-3.354,-32.145l-5.007,-0.374l-5.901,-50.085l44.228,19.181l44.164,-7.395l33.773,14.605l-29.348,-29.324l-44.228,-11.795l-38.326,-23.58l8.88,-41.276l56.004,32.423l0.008,0.003l12.176,-24.397l-44.635,-46.338l26.495,-23.571l55.797,40.892l3.241,-32.075l18.029,-12.341l-15.133,-14.164l41.303,-8.853l58.911,26.541l-32.443,-73.71l38.362,-5.902l19.16,32.63c-0.063,-1.524 -0.07,-3.064 -0.02,-4.621l6.144,-3.996l-7.579,-47.583l23.537,2.932l5.591,18.375l15.038,-52.263l20.639,17.697l-11.795,61.897l13.306,26.54l-1.465,6.432l18.094,9.505c0.413,-2.761 0.999,-5.27 1.695,-7.538l-6.57,-24.565l4.487,-15.241l-20.668,-32.004l31.23,-3.873l7.1,-24.12l13.474,10.8c0.765,-1.697 1.657,-3.327 2.691,-4.881l45.703,-8.87c0,0 -5.45,6.238 -9.705,17.181l18.008,8.002l26.297,-32.514l22.158,22.087l-24.313,28.758l-1.511,20.906l33.868,-27.548l23.001,12.755c7.844,-5.833 17.737,-9.834 30.119,-9.834c0,0 27.945,5.902 29.447,-13.262l36.841,4.418c-0,0 -0,9.558 -5.601,19.014l21.835,16.373l-59,44.193l-6.934,51.04l4.157,4.992l38.153,-56.032l11.857,47.169l-23.625,29.501l34.323,-5.151c-0.665,-20.153 -10.703,-37.572 -10.703,-37.572l45.648,-1.493c1.591,8.096 2.369,15.618 2.469,22.603l22.584,-22.606l23.58,26.54l-12.75,13.578l22.004,10.738c-65.304,7.744 -59.715,44.165 -59.715,44.165c-0,6.243 -0.999,11.72 -2.751,16.524l11.98,3.423l50.05,-29.517l20.709,47.196l-57.369,31.052l10.161,5.762l-5.976,16.239l29.577,-5.928l0,32.468l-56.05,29.447l-17.61,40.071l49.276,-9.871l-6.423,10.295l54.414,-2.197l0,38.345l-67.853,8.826l-27.997,31.765l45.717,-14.1l-12.561,22.307l53.797,-28.142l5.91,41.232l-58.919,26.55l-50.13,11.775l41.277,32.416l5.893,73.727l-50.111,0l-0,-67.843l-35.022,-16.677l8.465,15.213l-22.525,19.169l34.309,-0l-2.951,26.523l-85.504,-11.813l29.536,11.813l-17.75,29.463l-49.219,-17.345l17.56,12.957l-13.243,55.244l-18.491,-15.065l-13.205,14.321l-47.161,-35.384l-29.5,-35.366l-0,58.982l14.763,41.232l-29.419,17.715l-26.229,-64.069c-35.623,17.12 -19.533,64.038 -19.533,64.038l-22.043,-26.514c-10.301,-48.654 24.994,-57.471 24.994,-57.471c6.282,-4.711 11.224,-9.525 15.051,-14.353l-1.758,-48.988l-23.571,50.066l-70.768,53.098l-23.545,-29.499l73.674,-47.197l3.805,-8.248l-19.313,11.954l12.58,-30.861l-37.287,20.19l-3.977,12.912l-68.559,79.575l-13.279,-44.227l22.269,-22.262l-9.839,-21.411l0.035,-0.02c-0.019,0.004 -0.039,0.007 -0.059,0.01c0,0 -6.815,1.911 -15.684,6.3l-18.076,22.602l-8.403,-3.221c-5.509,6.158 -10.014,13.572 -12.232,22.392l-17.323,-33.722l-0.367,-0.141l0.191,-0.203l-10.498,-20.435c0,-0 15.285,-19.403 49.307,-20.801l8.178,-8.691l-20.62,-35.357l-38.326,53.072l-44.21,-29.474l55.978,-41.258l0.002,-0.007l-0.009,0.008l-59.653,17.66l2.981,-23.862l-19.937,6.201l-29.474,-35.393l88.402,-23.572l3.547,-7.087Zm-37.097,-152.826l36.501,-8.1l19.702,-17.039l-21.201,-9.465l-33.865,11.768l-33.537,-2.505c3.955,5.893 15.806,21.534 32.4,25.341Zm458.089,-270.649l-11.87,35.607l17.688,38.308l17.669,-70.731l11.939,-6.918c-8.946,-1.489 -22.517,-2.11 -35.426,3.734Zm-310.387,534.667l-11.08,13.854c3.665,-1.139 7.644,-2.575 11.852,-4.387l-0,-8.346l-0.772,-1.121Zm-31.587,-471.438l-4.489,10.686l9.516,42.717l36.205,-6.799c0.14,-4.04 0.505,-8.27 1.121,-12.697l19.488,-10.518l3.022,-3.877l-47.178,-2.96l-17.685,-16.552Zm447.254,111.118l17.477,4.993c2.085,-9.632 0.979,-17.011 0.979,-17.011c-0.056,-0.23 -0.112,-0.46 -0.167,-0.69c-6.104,5.407 -12.48,9.564 -18.289,12.708Zm-9.833,80.272l48.937,10.881l5.195,-1.041l-38.497,-13.467l-3.16,0.43l-12.475,3.197Zm19.439,134.651l-0.002,0.007l0.009,-0.008l-0.007,0.001Zm-92.854,134.609l29.016,19.36l-5.445,-12.469l-8.168,-26.117l-15.403,4.097l-0,15.129Z"
        :style="{
          fill: productColors.secondary_1.value,
          transition: 'all 500ms ease',
          stroke: 'black',
          strokeWidth: '2',
        }"
      />
      <use
        id="logo"
        xlink:href="#_Image1"
        x="0"
        y="0"
        width="525px"
        height="416px"
        transform="matrix(1.07305,0,0,1.07305,927.578,1957.81)"
      />
      <path
        id="text-mask"
        d="M2254.48,1487.73c-0.438,0.09 -0.778,0.17 -1.037,0.259c-691.797,176.723 -1380.63,170.292 -2086.82,45.862c1.824,-9.54 3.56,-19.082 5.205,-28.614c5.643,-31.566 11.276,-63.132 16.132,-94.787c5.374,-35.982 9.54,-72.136 14.996,-108.127c7.377,-48.726 14.837,-97.023 25.194,-145.238c6.445,-30.001 14.382,-59.449 24.551,-88.717c3.455,-9.941 6.047,-17.564 9.794,-27.23c692.924,114.199 1313.91,112.976 1865.39,-23.078c3.121,-0.778 9.6,-1.976 18.792,-3.97c5.844,19.005 11.577,37.788 16.79,57.057c5.726,21.165 8.355,31.459 13.12,51.238c13.215,54.847 29.955,128.647 43.214,195.271c8.388,42.152 17.238,83.971 26.689,125.936c3.201,14.566 5.464,29.312 7.976,44.138"
        style="fill: none"
      />
      <clipPath id="_clip2">
        <path
          d="M2254.48,1487.73c-0.438,0.09 -0.778,0.17 -1.037,0.259c-691.797,176.723 -1380.63,170.292 -2086.82,45.862c1.824,-9.54 3.56,-19.082 5.205,-28.614c5.643,-31.566 11.276,-63.132 16.132,-94.787c5.374,-35.982 9.54,-72.136 14.996,-108.127c7.377,-48.726 14.837,-97.023 25.194,-145.238c6.445,-30.001 14.382,-59.449 24.551,-88.717c3.455,-9.941 6.047,-17.564 9.794,-27.23c692.924,114.199 1313.91,112.976 1865.39,-23.078c3.121,-0.778 9.6,-1.976 18.792,-3.97c5.844,19.005 11.577,37.788 16.79,57.057c5.726,21.165 8.355,31.459 13.12,51.238c13.215,54.847 29.955,128.647 43.214,195.271c8.388,42.152 17.238,83.971 26.689,125.936c3.201,14.566 5.464,29.312 7.976,44.138"
        />
      </clipPath>
      <g clip-path="url(#_clip2)">
        <path
          id="curve"
          d="M182.647,1450.98c710.413,142.829 1296.56,122.841 2057.09,-32.204"
          style="fill: none"
        />
        <g id="custom-text" transform="matrix(450,0,0,450,2428.09,1476.13)"></g>
        <text
          x="0px"
          y="1476.13px"
          :style="{
            fontWeight: 700,
            fontSize: `${text.size}px`,
            fill: text.color.value,
            transition: 'all 250ms',
            fontWeight: 700,
            fontFamily: `${text.font}`,
            transform: `translate(0px, ${-200 + text.size - text.size / 2}px`,
          }"
        >
          <textPath xlink:href="#curve" startOffset="50%" text-anchor="middle">
            {{ text.message }}
          </textPath>
        </text>
      </g>
    </g>
    <defs>
      <svg:style>
        {{ fontFace }}
      </svg:style>
    </defs>
    <image
      id="embdedImage"
      :href="logo.path"
      x="50%"
      y="84%"
      :style="`width: ${logo.size}%; height: ${
        logo.size
      }%; transform: translate(-${logo.size / 2}%, -${logo.size / 2}%)`"
    />
  </svg>
</template>

<script>
import { getFontFace } from "@/assets/fonts/fontsBase64";
import { computed } from "vue";
export default {
  name: "Beanie_2",
  props: ["productColors", "logo", "text"],
  setup(props) {
    const fontFace = computed(() => getFontFace(props.text.font));
    return {
      fontFace,
    };
  },
};
</script>

<style lang="scss" scoped></style>
